<template>
	<div style="width:100%;float:left" class = "condition-wraps">
		<div class="arrow-up" :style="(editCondition ? 'margin-left:380px;': 'margin-left:350px;') + 'margin-top:0px'"></div>
		<div v-if="showLoader" class="spinner-border" style="margin:auto;display:block;"></div>

		<div
			v-else
			class="popover-custom-wrap"
			style="width: 0px !important;position: absolute !important; padding: 2px !important;"
		>
			<div style="padding:20px;max-height: 400px;overflow-y: scroll;padding-bottom:100px" v-if="isShowTargetMeasure" class = "custom_height main_form_block">
				<div
					class="form-group row"
					style="margin-bottom:15px !important"
					v-for="(item,index) in conditionList"
					:key="'prefilledActions_' + index"
				>
					<div class="col-md-3" :class = "checkLength(item.type) ? 'col-md-5' : 'col-md-3'" style="padding-right:0px">
						<multiselect
							style="padding:0px;padding-left:3px;height:0px"
							v-model="item.type"
							class="form-control multi-dropdown select_filter"
							placeholder="Select Type"
							label="name"
							deselectLabel
							selectedLabel
							:disabled="disableTheSelected[index]"
							selectLabel
							openDirection="below"
							:options="typeList? typeList:[]"
							track-by="id"
							ref="multiselect"
							:multiple="false"
							:taggable="false"
							@input="setRange(item.type, index)"
							@remove = "resetItem($event, index)"
						></multiselect>
					</div>
					<div class="col-md-2" style="padding-right:0px" v-if="item && item.type && !item.type.action">
						<multiselect
							v-model="item.condition"
							class="form-control multi-dropdown select_filter"
							placeholder="Select"
							label="name"
							deselectLabel
							:disabled="disableTheSelected[index]"
							selectedLabel
							openDirection="below"
							selectLabel
							:options="(item.type ? (conditionalRange? conditionalRange:[]):[])"
							track-by="id"
							ref="multiselect"
							:multiple="false"
							:taggable="false"
							style="height:0px"
							@select = "SelectConditionType(item)"
							v-if="item.type && item.type.id && item.type.id=='global_rating_count_decrease'"
						></multiselect>
						<multiselect
							v-model="item.condition"
							class="form-control multi-dropdown select_filter"
							placeholder="Select"
							label="name"
							deselectLabel
							:disabled="disableTheSelected[index]"
							selectedLabel
							openDirection="below"
							selectLabel
							:options="(item.type ? (rangeList? rangeList:[]):[])"
							track-by="id"
							ref="multiselect"
							:multiple="false"
							:taggable="false"
							style="height:0px"
							@select = "SelectConditionType(item)"
							v-else
						></multiselect>
					</div>
					<div v-if="item && item.type && item.type.attr_data_type =='text' && item.condition.id!='ispresent' && item.condition.id!='isnotpresent'"  class="col-md-4" style="padding-right: 0px;">
										<input
											style="min-height: 43px;"
											type="text"
											placeholder="Text"
											required="true"
											:disabled="(item.type ? (disableTheSelected[index]):true)"
											v-model="item.value"
											class="form-control"
											id="value"
											@click="resetValidation()"
										>
					</div>
					<div  v-if="item && item.type && item.type.attr_data_type =='single-select'" class="col-md-4" style="padding-right: 0px;">
										<multiselect
											v-model="item.value"
											:options="valueList"
											ref="multiselect"
											label="name"
											track-by="name"
											@tag="addValue($event,index)"
											open-direction="bottom"
											:taggable="true"
											placeholder="Type"
											class="form-control multi-dropdown select_filter"
											selectLabel
											deselectLabel
											selectedLabel
											style="margin-left:0px;max-height:40px;height:0px"
											:multiple="false"
											@input="resetValue(item.value,index)"
										>
										</multiselect>
									</div>
									<div v-if="item && item.type && item.type.attr_data_type && item.type.id=='country' && item.type.attr_data_type=='multiselect'" class="col-md-4" style="padding-right: 0px;">
										<multiselect
											v-model="item.value"
											:options="countryList"
											:searchable="true"
											ref="multiselect"
											label="country_code"
											track-by="country_code"
											open-direction="bottom"
											placeholder="Country Code"
											class="form-control multi-dropdown col-md-12 select_filter"
											style="max-height:42px"
											id="countryData"
											:closeOnSelect = "true"
											:multiple="true"
											@select = "changeHeight"
											@remove="reduceHeight"
										></multiselect>
									</div>
									<div v-if="getValueTypeUrlLoader && item.type.value_type_url=='/vendor'" class="spinner-border" style="margin-left:30px;display:block;"></div>
									<div v-if="item && item.type && (item.type.attr_data_type=='multiselect' || item.type.attr_data_type=='singleselect') && item.type.id!='country' && !getValueTypeUrlLoader" class="col-md-4" style="padding-right: 0px;">
									<multiselect
										v-model="item.value"
										class="form-control multi-dropdown select_filter"
										placeholder="Type"
										label="name"
										deselectLabel
										selectedLabel
										selectLabel
										:options="valueList"
										track-by="name"
										ref="multiselect"
										@tag="addMultiValue($event,index,item.type.attr_data_type)"
										@select="item.type.attr_data_type=='singleselect'? updateSingleValue($event,index) : 'changeHeight' "
										:multiple="true"
										:taggable="true"
										style="height:0px"
										openDirection="bottom"
										@remove="item.type.attr_data_type=='multiselect' ? reduceHeight : multiValue=false"
									></multiselect>

									</div>
										<div v-if="item && item.type && item.type.attr_data_type=='number'" class="col-md-2" style="padding-right: 0px;">
										<input
											style="min-height: calc(1.5em + .75rem + 6px)"
											type="number"
											placeholder="Value"
											@blur="checkGreater($event, item, index);"
											v-model="item.value"
											class="form-control"
											id="dailyBudget"
											onkeydown='javascript: return event.keyCode == 69 ? false : true'
											@click="resetValidation()"
										>
									</div>
									<div  class="col-md-2" v-if = "item && item.type && item.type.attr_data_type=='boolean'">
										<multiselect
											v-model="item.value"
											class="form-control multi-dropdown select_filter"
											placeholder="Select"
											deselectLabel
											selectedLabel
											selectLabel
											:options="booleanList"
											ref="multiselect"
											openDirection="bottom"
										></multiselect>
									</div>

					<div class="col-md-2" v-if="item && item.type && item.type.attr_data_type=='number' && item.condition && (item.condition.name=='Range' || item.condition.name=='Not In Range')" style="padding-right: 0px;">
						<input
							style="min-height: calc(1.5em + .75rem + 6px)"
							type="number"
							placeholder="Value"
							required="true"
							@blur = "checkSmall($event, item, index);"
							v-model="item.value2"
							class="form-control"
							id="value"
							onkeydown='javascript: return event.keyCode == 69 ? false : true'
							@click="resetValidation()"
						>
					</div>
					<div
						v-if="item && item.type &&item.type.is_of_attr "
						class="form-group row col-md-3"
						>
						<p style="margin:7px;margin-right:10px">Of</p>
						<multiselect
							v-model="item.attribute"
							class="form-control multi-dropdown col-md-9 select_filter"
							placeholder="Select"
							label="name"
							deselectLabel
							selectedLabel
							selectLabel
							:disabled="disableTheSelected[index]"
							:options="(item.type&&item.condition&&item.value) ? (keywordAttributionList? keywordAttributionList:[] ):[]"
							track-by="name"
							ref="multiselect"
							:multiple="false"
							:taggable="false"
							style="height:0px"
						></multiselect>
					</div>

					<div v-show="addCondition" style="padding-top:8px;margin-left:5px">
						<button
							@click="addConditionToList($event,item.type,index)"
							v-if="((conditionList.length !=(cloneOfTypeList.length-preFilledTypeList.length))&&(index == conditionList.length-1) && (item.type && (item.value.length || (item.condition.id == 'ispresent' || item.condition.id == 'isnotpresent')) &&item.condition)&&((item.value2&&(item.condition.name=='Range' || item.condition.name=='Not In Range'))||(item.condition.name!='Range'|| item.condition.name!='Not In Range')) && source ) && operationType != 'OR'"
							class="btn btn-primary add-new-campaign"
						>
							AND
						</button>
						<button
							@click="addConditionToList($event,item.type,index)"
							v-if="((conditionList.length !=(cloneOfTypeList.length-preFilledTypeList.length))&&(index == conditionList.length-1) && (item.type && (item.value.length || (item.condition.id == 'ispresent' || item.condition.id == 'isnotpresent')) &&item.condition)&&((item.value2&&(item.condition.name=='Range' || item.condition.name=='Not In Range'))||(item.condition.name!='Range'|| item.condition.name!='Not In Range')) && source ) && operationType != 'AND'"
							class="btn btn-primary add-new-campaign"
						>
							OR
						</button>
						<button
							v-if="(!(automationId && conditionList.length<1))&&(item.type &&  (item.value.length || (item.condition.id == 'ispresent' || item.condition.id == 'isnotpresent')) &&item.condition)&&((item.value2&&(item.condition&&item.condition.name=='Range'|| item.condition.name=='Not In Range'))||(item.condition&&item.condition.name!='Range'|| item.condition.name!='Not In Range'))"
							@click="removeConditionFromList($event,index,item.type)"
							class="btn btn-primary add-new-campaign"
							style="background-color:red"
						>X</button>
					</div>
				</div>
				<!-- <span v-if="!isAllFields"  class="col-sm-2"  style="color:red;font-size:13px;padding:10px">Provide all fields to proceed</span> -->
				<span v-if="!isAllFields && !rangeValidationWrong" class ="no-data-style mr-1" >Provide all fields to proceed.</span>
				<span v-if="multiValue" class ="no-data-style mr-1" >Single select should have exactly one value.</span>
				<span  v-if ="rangeValidationWrong" class ="no-data-style" >Value1 should be less than value2</span>

			</div>
			<div
				v-else
				class="spinner-border"
				style="margin:auto;display:block;margin-top:20px;margin-bottom:15px;"
			></div>

			<div style="display:flex;justify-content:center;background-color:white;">
				<div
					v-if="showSaveLoader"
					class="spinner-border"
					style="margin:auto;display:block;margin-bottom:10px;margin-top:10px"
				></div>
				<div v-else>
					<button type="button" class="btn btn-secondary" v-on:click="reset" data-dismiss="modal">Cancel</button>
					<button
						type="button"
						class="btn btn-primary"
						@click="submit($event)"
						data-dismiss="modal"
						id="submit"
					>Save</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Multiselect from "vue-multiselect";
	import CampaignFormDropDown from "@/components/add-campaign/CampaignFormDropDownNew";
	
	export default {
		name: "ConditionsAutomation",
		components: {
			CampaignFormDropDown,
			Multiselect
		},
		props: [
			"preFilledTypeList",
			"automationId",
			"editCondition",
			"editConditionRow",
			"editConditionTarget",
			"addCondition",
			"conditionRowId",
			"operationType",
			"countryList"
		],
		computed: {},
		mounted() {
			this.source = this.editConditionTarget;
			this.getTargetTypeList(this.source);
			},
		updated(){

		//	adjustHeight(){
		
				if(!this.editCondition || this.editConditionRow.type.attr_data_type == 'multiselect'){
					if(this.editConditionRow && this.editConditionRow.value.length){
						let valueLength = this.editConditionRow.value.length
						let popUpHeight = document.getElementsByClassName("custom_height")[0].offsetHeight;
						let newHeight = popUpHeight + ((valueLength + 1) * 6);
						$('.custom_height').css('height', newHeight+'px');
					}
					else if(this.disableTheSelected && this.disableTheSelected.length){
						let valueLength = this.disableTheSelected.length
						let popUpHeight = document.getElementsByClassName("custom_height")[0].offsetHeight;
						let newHeight = popUpHeight + ((valueLength + 1) * 6);
						$('.custom_height').css('height', newHeight+'px');
					}
				}

			//},
		},
		watch: {

			targetType(){

				this.setRangeList(this.targetType)
			},
			preFilledTypeList() {
				this.filledTypeList = JSON.parse(
					JSON.stringify(this.preFilledTypeList)
				);
				this.getRemainingTypeListToFill(this.filledTypeList);
			},
			sendNotification() {
				if (this.sendNotification) {
					this.addEmail();
				} else {
					this.emailList = [];
				}
			},
			source() {
				if (!this.source) {
					this.resetTargetData();
				}
			}
		},
		data() {
			return {
				
				conditionalRange:[
				{ id: ">", name: ">" },
				],
				adjustHeight:false,
				conditionList: [
					{
						type: "",
						condition: "",
						value: "",
						value2: "",
						attribute: ""
					}
				],
				title: "",
				source: "",
				executeOn: "",
				typeList: [],
				cloneOfTypeList: [],
				filledTypeList: [],
				rangeList: [],
				booleanList:['TRUE','FALSE'],
				showExecuteTimeList: false,
				executeTimeList: [],
				executeTime: [],
				showForm: false,
				showLoader: true,
				tagData: [],
				tagOptions: [],
				sendNotification: false,
				emailList: [],
				isShowTargetMeasure: true,
				showExecuteTimeLoader: false,
				showSaveLoader: false,
				disableTheSelected: [],
				keywordAttributionList: [],
				targetType:'',
				value:'',
				valueList:[],
				getValueTypeUrlLoader:false,
				isAllFields:true,
				toggleVariable:false,
				selectedTargetValueType:'',
				rangeValidationWrong:false,
				countryRangeList:[],
				multiValue:false
			};
		},
		methods: {
			initiateData(){
				this.showLoader = false;
				if (this.addCondition) {
				} else if (this.editCondition) {
					this.conditionList = [];
					if(this.editConditionRow.type && this.editConditionRow.type.value_type_url=='/vendor'){
						this.getValueTypeUrlLoader = true;
						const vm = this;
						this.$store.dispatch("getAllVendor").then(res=>{
							vm.valueList = res.filter(v=>v.name);
							vm.getValueTypeUrlLoader = false;
							vm.conditionList[0].value.forEach((res) => {
								if(!res.id){
									vm.valueList.push(res)
								}
							})
							vm.conditionList.forEach(condition=>{
								if(condition && condition.type && condition.type.id=='sold_by'){
									let attr_type = vm.cloneOfTypeList.find(type=>type.id==condition.type.id)
									attr_type?condition.type.attr_data_type=attr_type.attr_data_type:''
								}
								else if(condition && condition.type && condition.type.id=='ships_from'){
									let attr_type = vm.cloneOfTypeList.find(type=>type.id==condition.type.id)
									attr_type?condition.type.attr_data_type=attr_type.attr_data_type:''
								}
							})
						})
					}
					// if(this.editConditionRow.value.length){
					// 	let valueLength = this.editConditionRow.value.length
					// 	let popUpHeight = document.getElementsByClassName("custom_height")[0].offsetHeight;
					// 	let newHeight = popUpHeight + (valueLength * 2);
					// 	$('.custom_height').css('height', newHeight+'px');
					// }
					if(this.editConditionRow.type && this.editConditionRow.type.id=='country'){
						this.countryRangeList = this.editConditionRow.type.filterType
					}
					this.selectedTargetValueType = this.editConditionRow.type.name
					this.targetType = this.editConditionRow.type.attr_data_type
					this.conditionList.push(this.editConditionRow);
					if(this.editConditionRow.value.length){
						this.adjustHeight = true;
					}
					else{
						this.adjustHeight = false;
					}

				}
				this.toggleVariable = !this.toggleVariable
			
			},
			updateSingleValue(data,index){
				let dataClone = JSON.parse(JSON.stringify(this.conditionList[index]))
				dataClone.value = []
				dataClone.value.push(data)
				this.conditionList.splice(index, 1, dataClone)
				this.multiValue = false
				// this.conditionList[index].value = []
				// this.conditionList[index].value.splice(index,1)
				// this.conditionList.splice(1,0)
				// this.conditionList[index].value.push(JSON.parse(JSON.stringify(data)))
				// this.conditionList.splice(1,0)
			},
			resetValidation(){
				this.rangeValidationWrong = false,
				this.isAllFields = true
			},
			checkSmall(event, item, index){
				if(item.value){
					if(parseInt(event.currentTarget.value) < parseInt(item.value) || parseInt(event.currentTarget.value) == parseInt(item.value)){
						this.rangeValidationWrong = true;
						let data = this.conditionList;
						data[index].value2 = '';
						this.conditionList = JSON.parse(JSON.stringify(data))
					}
					else{
						this.rangeValidationWrong = false
					}
				}
			},
			checkGreater(event, item, index){
				if(item.value2){
					if(parseInt(event.currentTarget.value) > parseInt(item.value2) || parseInt(event.currentTarget.value) == parseInt(item.value2)){
						this.rangeValidationWrong = true
						let data = this.conditionList;
						data[index].value = '';
						this.conditionList = JSON.parse(JSON.stringify(data))
					}
					else{
						this.rangeValidationWrong = false
					}
				}
			},
			setRange(data, index){

				if(data){
					if(data && data.id=='country'){
						this.countryRangeList = data.filterType
					}
					this.selectedTargetValueType = data.name;
					this.targetType = (data || {}).attr_data_type
					if(data && data.attr_data_type){
						this.setRangeList(data.attr_data_type)
					}
					if(data && data.value_type_url=='/vendor'){
						this.getValueTypeUrlLoader = true;
						const vm = this;
						this.$store.dispatch("getAllVendor").then(res=>{
							vm.valueList = res.filter(v=>v.name);
							vm.getValueTypeUrlLoader = false;
						})
					}

					this.conditionList[index].value = ""
					this.conditionList[index].condition = ""
					this.conditionList[index].value2 = ""

				}
				this.resetValidation()
			},
			checkLength(data){

				if(data && data.name && data.name.length>18){
					return true
				}
				else return false
			},
			resetValue(option,index) {
				if (option.length) {
					this.conditionList[index].value = option[option.length - 1];
				} else {
					this.conditionList[index].value = []
				}
				this.resetValidation()
			},
			addValue(name,index) {
				this.conditionList[index].value = [];
				var pay = { name: name };
				this.valueList.push(pay);
				(this.conditionList[index].value).push(pay);

			},
			changeHeight(){
				if(!this.editCondition){
					let popUpHeight = document.getElementsByClassName("custom_height")[0].offsetHeight;
					let newHeight = popUpHeight + 40
					$('.custom_height').css('height', newHeight+'px');
				}


			//	$(".custom_height").height(newHeight);
			},
			reduceHeight(){

				let popUpHeight = document.getElementsByClassName("custom_height")[0].offsetHeight;
				let newHeight = popUpHeight - 40
				$('.custom_height').css('height', newHeight+'px');
			//	$(".custom_height").height(newHeight);
			},
			addMultiValue(name,index,type){
				if(type=='singleselect'){
					let dataClone = JSON.parse(JSON.stringify(this.conditionList[index]))
					dataClone.value = []
					this.conditionList.splice(index, 1, dataClone)
					this.multiValue = false
				}
				if(this.conditionList[index].value == ''){
					this.conditionList[index].value = [];
				}
				var pay = { name: name };
				this.valueList.push(pay);
				(this.conditionList[index].value).push(pay);
				this.resetValidation()
			},
			setRangeList(type){

				if(type=='multiselect' || type=='single-select' || type == 'text' || type=='singleselect'){
					if(this.selectedTargetValueType && this.selectedTargetValueType == 'ASIN Status'){
						this.rangeList = [
							{ id: "equal", name: "Equals" }
						]
					}
					else if(this.selectedTargetValueType && this.selectedTargetValueType == 'Amazon Choice Attribute'){
							this.rangeList = [
								{ id: "ispresent", name: "is Present" },
								{ id: "isnotpresent", name: "is not Present" },
								{ id: "contains", name: "Contains" },
								{ id: "notcontains", name: " Not contains" }
							]
						}
					else if(this.selectedTargetValueType && this.selectedTargetValueType == 'Country Code'){
						this.rangeList = this.countryRangeList
						// this.rangeList = [
						// 	{ id: "contains", name: "Contains" }
						// ]
					}
					else{
						this.rangeList = [
							{ id: "startwith", name: "Starts with" },
							{ id: "endwith", name: "Ends with" },
							{ id: "contains", name: "Contains" },
							{ id: "notcontains", name: "Not Contains" },
							{ id: "equal", name: "Equals" },
							{ id: "notequals", name: "Not Equals" }
						]
					}
				}
				else if(type == 'boolean'){
					this.rangeList = [
						{id: "equal", name: "Equals"}
					]
				}
				else{
					this.rangeList = [
						{ id: "<", name: "<" },
						{ id: ">", name: ">" },
						{ id: "=", name: "=" },
						{ id: "!=", name: "!="},
						{ id: "range", name: "Range" },
						{ id: "notinrange", name: "Not In Range" }
					]
				}

				this.rangeList.splice(0,0)
				this.conditionList.splice(0,0)
			},
			SelectConditionType(item){
				if(this.selectedTargetValueType && this.selectedTargetValueType == 'ASIN Status'){
					item.value = 'ASIN Not Found';
					this.disableTheSelected.push(true);
				}
				this.resetValidation()
			},
			getKeywordAttributeList(data) {
				this.$emit('setHoverSelected', true)
				// if (data && data.is_of_attr) {
				// 	this.keywordAttributeLoader = true;
				// 	const vm = this;
				// 	var payload = {
				// 		type: "of_val"
				// 	};
				// 	this.$store
				// 		.dispatch("automation/getAttributeList", payload)
				// 		.then(res => {
				// 			vm.keywordAttributionList = res;
				// 			vm.keywordAttributeLoader = false;
				// 		});
				// }
			},
			getRemainingTypeListToFill(filledTypeList) {
				var remainingList = [];

				for (var i = 0; i < this.typeList.length; i++) {
					{
						var flag = false;
						for (var j = 0; j < filledTypeList.length; j++) {
							if (filledTypeList[j].id == this.typeList[i].id) {
								flag = true;
								break;
							}
						}
						if (flag == false) {
							remainingList.push(this.typeList[i]);
						}
					}
				}

				this.typeList = remainingList;
			},
			removeSelectedTypeValueFromList(selectedType) {
				for (var i = 0; i < this.typeList.length; i++) {
					if (this.typeList[i].name == selectedType.name) {
						this.typeList.splice(i, 1);
					}
				}
			},
			addDeSelectedTypeValueIntoList(deSelectedType) {
				var duplicate = false;
				for (var i = 0; i < this.typeList.length; i++) {
					if (this.typeList[i].name == deSelectedType.name) {
						duplicate = true;
						break;
					}
				}
				if (!duplicate) {
					this.typeList.push(deSelectedType);
				}
			},
			addConditionToList(e, selectedType, index) {
				e.stopPropagation();
				if(selectedType.name != 'ASIN Status'){
					this.disableTheSelected.push(true);
				}
				var conditionRow = {
					type: "",
					condition: "",
					value: "",
					value2: "",
					attribute: ""
				};
				this.removeSelectedTypeValueFromList(selectedType);
				this.conditionList.push(conditionRow);
			},
			removeConditionFromList(e, index, deSelectedType) {
				e.stopPropagation();
				this.disableTheSelected.pop();
				if (deSelectedType) {
					this.addDeSelectedTypeValueIntoList(deSelectedType);
				}
				this.conditionList.splice(index, 1);
				if (this.conditionList.length < 1) {
					var conditionRow = {
						type: "",
						condition: "",
						value: "",
						value2: "",
						attribute: ""
					};
					this.conditionList.push(conditionRow);
				}
			},
			reset() {
				$("ul.dropdown-menu").removeClass("show");

				var conditionRow = {
					type: "",
					condition: "",
					value: "",
					value2: "",
					attribute: ""
				};
				(this.conditionList = []), this.conditionList.push(conditionRow);
				this.toggle();
			},
			toggle() {
				this.$emit("toggleModal");
			},
			getTargetTypeList(id) {
				const vm = this;
				if (id && id.name) {
					this.resetTargetData();
					this.isShowTargetMeasure = false;
					let payload = {
						entityType: id.name
					};
					this.$store
						.dispatch("automation/getAttributeList", payload)
						.then(res => {

							// var payload = {
							// 	type: "of_val"
							// };
							// vm.$store
							// 	.dispatch("automation/getAttributeList", payload)
							// 	.then(resp => {
							for(var i=0;i<JSON.parse(res[0].name).length;i++)
								 {
								if(
									JSON.parse(res[0].name)[i].is_of_attr
										? true
										:false
								)
									vm.keywordAttributionList = JSON.parse(
										res[0].name
									)[i].is_of_attr;
							}
							//vm.targetType = res[0].attr_data_type;
							vm.typeList = JSON.parse(res[0].name);
							vm.cloneOfTypeList = JSON.parse(res[0].name);
							vm.isShowTargetMeasure = true;
							vm.filledTypeList = JSON.parse(
								JSON.stringify(vm.preFilledTypeList)
							);
							vm.getRemainingTypeListToFill(vm.filledTypeList);
							//	});
							vm.initiateData()

						});
				}
				else{
					this.initiateData()
				}
			},

			resetTargetData() {
				this.typeList = [];
				this.cloneOfTypeList = [];
				var conditionRow = {
					type: "",
					condition: "",
					value: "",
					value2: "",
					attribute: ""
				};
				(this.conditionList = []), this.conditionList.push(conditionRow);
			},
			getAllAutomationsList() {
				this.$store.dispatch("automation/getAutomations");
			},
			resetItem(data, index){
				var conditionRow = {
					type: "",
					condition: "",
					value: "",
					value2: "",
					attribute: ""
				};
				this.conditionList[index] = conditionRow
				let updateData = JSON.parse(JSON.stringify(this.conditionList))
				this.conditionList = JSON.parse(JSON.stringify(updateData))
				this.resetValidation()
			},
			submit(e) {

				e.stopPropagation();
				if(this.rangeValidationWrong){
					return ;
				}
				this.multiValue = false
				this.conditionList.forEach((condition)=>{
					if(condition && condition.type && condition.type.attr_data_type=='singleselect' && condition.value && condition.value.length>1){
						this.multiValue = true
					}
				})
				if(this.multiValue){
					return ;
				}
				this.isAllFields = true;
				if(this.conditionList && this.conditionList.length && (!this.conditionList[0].condition || !this.conditionList[0].type || (!this.conditionList[0].value && this.conditionList[0].condition.id!='ispresent' && this.conditionList[0].condition.id!='isnotpresent') || (this.conditionList[0].condition && Array.isArray(this.conditionList[0].condition) && this.conditionList[0].condition.length == 0) || (this.conditionList[0].type && Array.isArray(this.conditionList[0].type) && this.conditionList[0].type.length == 0) ||  (this.conditionList[0].value && Array.isArray(this.conditionList[0].value) && this.conditionList[0].value.length == 0 ) || (this.conditionList[0].condition.id == "range" && !this.conditionList[0].value2) || (this.conditionList[0].condition.id == "notinrange" && !this.conditionList[0].value2) || (this.conditionList[0].type.is_of_attr && !this.conditionList[0].attribute))){
					this.isAllFields = false;
				}
				this.$emit('setHoverSelected', true)
				const vm = this;

				if(this.isAllFields){
					this.conditionList.forEach((condition, index) => {
						if (
							condition.condition == "" && condition && condition.type && !condition.type.action||
							condition.type == "" ||
							(condition.value == "" && condition.condition.id != 'ispresent' && condition.condition.id != 'isnotpresent')
						) {
							vm.conditionList.splice(index, 1);
						}
					});
					var payload = {
						id: this.addCondition
							? this.automationId
							: this.editCondition
							? this.conditionRowId
							: "",
						trigger: this.conditionList,
						operationType: (this.operationType ? this.operationType : '')
					};
					if (this.addCondition && this.automationId) {
						this.showSaveLoader = true;
						this.$store
							.dispatch("automation/addAutomationCondition", payload)
							.then(response => {
								vm.$emit("AddConditionsListUIUpdate", response);
								//	vm.getAllAutomationsList();
								vm.toggle();
								vm.reset();
							});
					} else if (this.editCondition && this.conditionRowId) {
						this.showSaveLoader = true;
						//this.$store.state.automation.showEditConditionLoaderVal = true
						vm.$store
							.dispatch("automation/editAutomationCondition", payload)
							.then(response => {
								vm.$emit("updateContionList", vm.conditionList);
								//	vm.$store.state.automation.showEditConditionLoaderVal=false
								vm.toggle();
								vm.reset();
								vm.showSaveLoader = false;
							});
						//	vm.$emit("showConditionEditLoader");
					}
				}

			}
		}
	};
</script>
<style lang="scss">
.popover-custom-wrap {
	width: 100%;
	min-width: 800px;
	background: #d4d4d4;
	padding: 2px;
	border-radius: 5px;
}
.popover-custom-wrap {
	.multiselect__input{
		width: 0px !important;
		position: absolute !important;
		padding: 0px !important;
	}
}
.arrow-up {
	width: 0;
	height: 12px;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 10px solid #d4d4d4;
}
.condition-wraps {
	.multiselect__tags-wrap{
		display:inline-grid
	}
}
.condition-wraps {
	.multiselect__strong{
		display:block;
	}
}
</style>
